/* eslint-disable max-len */
import React from 'react'
import { Nav, NavItem } from 'react-bootstrap'
import { Switch, Route, Redirect } from 'react-router-dom'
import RouteMatcher from '~/RouteMatcher'
import { View } from '~/views';

import SimControlScreen from '../simcontrol/SimControlScreen'
import DeviceHistoryScreen from '../history/DeviceHistoryScreen'
import DeviceEventScreen from '../history/DeviceEventScreen'
import DeviceInfoScreen from './DeviceInfoScreen'
import DeviceUsersScreen from './DeviceUsersScreen';
import DeviceRulesScreen from './DeviceRulesScreen';
import DeviceRuleScreen from './DeviceRuleScreen';

export default class DeviceHomeScreen extends React.Component {

  static routes = [
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/info" path="/project/:projectId/system/:systemId/device/:deviceId/info" exact component={DeviceInfoScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/sim" path="/project/:projectId/system/:systemId/device/:deviceId/sim" exact={undefined} component={SimControlScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/history" path="/project/:projectId/system/:systemId/device/:deviceId/history" exact={undefined} component={DeviceHistoryScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/event" path="/project/:projectId/system/:systemId/device/:deviceId/event" exact={undefined} component={DeviceEventScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/access" path="/project/:projectId/system/:systemId/device/:deviceId/access" exact={undefined} component={DeviceUsersScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/rule" path="/project/:projectId/system/:systemId/device/:deviceId/rule" exact component={DeviceRulesScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId/rule/:ruleId" path="/project/:projectId/system/:systemId/device/:deviceId/rule/:ruleId" component={DeviceRuleScreen} />,
    
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/info" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/info" exact component={DeviceInfoScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/sim" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/sim" exact={undefined} component={SimControlScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/history" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/history" exact={undefined} component={DeviceHistoryScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/event" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/event" exact={undefined} component={DeviceEventScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/access" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/access" exact={undefined} component={DeviceUsersScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/rule" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/rule" exact component={DeviceRulesScreen} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/rule/:ruleId" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/rule/:ruleId" component={DeviceRuleScreen} />,
    
    <Redirect
      key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId"
      from="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId"
      to="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId/info" />,
    <Redirect
      key="/project/:projectId/system/:systemId/device/:deviceId"
      from="/project/:projectId/system/:systemId/device/:deviceId"
      to="/project/:projectId/system/:systemId/device/:deviceId/info" />,
  ]

  static tabKeys = [
    'info',
    'sim',
    'history',
    'event',
    'access',
    'rule',
    'rule',

    'info',
    'sim',
    'history',
    'event',
    'access',
    'rule',
    'rule'
  ]

  constructor( props ) {
    super( props );

    this.routeMatcher = new RouteMatcher( DeviceHomeScreen.routes, { missComponent : null } )

  }

  onTabSelected = ( key, evt ) => {
    const { history, match : { params : { projectId, systemId, deviceId, blueprintId } } } = this.props
    
    if ( blueprintId ) {
      history.push( `/project/${projectId}/system/${systemId}/blueprint/${blueprintId}/device/${deviceId}/${key}` )
    } else {
      history.push( `/project/${projectId}/system/${systemId}/device/${deviceId}/${key}` )
    }
  }

  render() {
    const { location } = this.props

    const matchResult = this.routeMatcher.find( location )
    const { matchIndex } = matchResult
    const activeKey = DeviceHomeScreen.tabKeys[matchIndex]
    
    return ( 
      <View style={{ display : 'flex', flexDirection : 'column', overflow : 'hidden' }}>
        <Nav bsStyle="tabs" activeKey={activeKey} onSelect={this.onTabSelected}>
          <NavItem eventKey="info">Info</NavItem>
          <NavItem eventKey="sim">Data</NavItem>
          <NavItem eventKey="history">History</NavItem>
          <NavItem eventKey="event">Events</NavItem>
          <NavItem eventKey="access">Access</NavItem>
          <NavItem eventKey="rule">Rules</NavItem>
        </Nav>

        <div style={{ flex : 1, overflow : 'auto', position : 'relative' }}>
          <Switch>
            {DeviceHomeScreen.routes}
          </Switch>
        </div>
      </View>
    )
  }
}
